<template>
  <AppAsideDialog v-bind="{ isOpened }" @close="closeAside">
    <IntlMsg
      v-bind="{ k: 'auth.signup.title', tag: 'h4' }"
      class="mb-7 text-xl font-semibold leading-7 sm:mb-10 sm:text-3xl"
    />
    <SignUpForm
      v-bind="{ provider, idkey: 'aside-dialog' }"
      class="mb-7 flex flex-col items-start sm:mb-10"
      @success="handleSuccess"
      @close="closeAside"
    />

    <SocialAuth
      v-bind="{ type: 'signup' }"
      class="border-y-2 border-gray-100 pb-6 pt-4 sm:pb-7 sm:pt-5"
    />

    <div class="mt-10">
      <IntlMsg
        v-bind="{ k: 'auth.signup.already-signed-up' }"
        class="mb-4 block text-lg font-semibold leading-6 sm:mb-6 sm:text-xl"
      />

      <div class="flex">
        <button
          class="c-btn c-btn--gray max-w-full text-lg font-semibold"
          @click="
            () => {
              closeAside()
              bus.emit('app::show-login-aside')
            }
          "
        >
          <IntlMsg v-bind="{ k: 'auth.login.action' }" class="truncate" />
        </button>
      </div>
    </div>
  </AppAsideDialog>
</template>

<script lang="ts" setup>
import { onUnmounted, ref, shallowRef } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import type { Provider } from '/@shared/auth'
import { bus, IntlMsg } from '/@shared/app'

import { AppAsideDialog } from '/@app'
import { SignUpForm, SocialAuth } from '/@auth'

import { useAuthStore } from '/@/stores'
import { useI18n } from '/@/i18n'

const authStore = useAuthStore()

const { locale } = useI18n()

const route = useRoute()
const router = useRouter()

const isOpened = ref(false)

const provider = shallowRef<Provider>()

const nextUrl = shallowRef<string>()
function handleSuccess() {
  if (nextUrl.value) location.assign(nextUrl.value)
  if (provider.value) provider.value = undefined

  if (route.path.includes('auth'))
    router.replace({
      name: 'HomePage',
      params: { lang: locale.value !== 'en' ? locale.value : '' },
    })

  closeAside()
}

function closeAside() {
  if (provider.value) {
    authStore.ignorePendingAuth()
    provider.value = undefined
  }

  isOpened.value = false
}
function openAside(params?: { next?: string; provider?: Provider }) {
  if (params?.next) nextUrl.value = params.next
  if (params?.provider) {
    provider.value = params.provider
    authStore.cleanupPendingAuthIgnore()
  }

  isOpened.value = true
}

bus.on('app::show-signup-aside', openAside)
onUnmounted(() => bus.off('app::show-signup-aside', openAside))
</script>
